export const langIdSelector = (state) => state.app.language;
export const translationsSelector = (state) => state.app.translations;
export const loginStateSelector = (state) => state.app.isLogedIn;
export const fuelTypesSelector = (state) => state.app.fuelTypes;
export const userDataSelector = (state) => state.app.userData;
